// 拒绝隐私之后多的简易详情页
export default {
  routes: [
    // 设置页
    {
      path: '/simple-detail',
      name: 'simple-detail',
      meta: {
        desc: '商品详情'
      },
      component: () => import(/* webpackChunkName: "settings" */ '../views/simpleDetail/detail.vue')
    }
  ]
}
